import React, { useState } from 'react';
import styles from './FAQ.module.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: 'What is Rupayya and how does it work?',
      answer: 'Rupayya is a peer-to-peer lending platform that connects lenders and borrowers who have pre-existing relationships. We provide a secure platform for creating formal lending agreements, managing repayments, and maintaining transaction records between family, friends, and acquaintances.'
    },
    {
      question: 'Is Rupayya safe to use for lending money?',
      answer: 'Yes, Rupayya implements multiple security layers including bank-grade encryption, multi-factor authentication, and secure payment processing. We provide formal documentation for all transactions and maintain proper records. However, users should still exercise due diligence when lending to acquaintances.'
    },
    {
      question: 'What are the fees for using Rupayya?',
      answer: 'Rupayya charges a nominal platform fee that covers documentation, payment processing, and customer support. The fee varies based on the loan amount and duration. There are no hidden charges, and all fees are clearly displayed before you confirm any transaction.'
    },
    {
      question: 'Can I use Rupayya for business transactions?',
      answer: 'Rupayya is designed specifically for personal lending between individuals who know each other. We do not support business-to-business transactions or lending to strangers. All users must have a pre-existing personal relationship.'
    },
    {
      question: 'What happens if someone defaults on repayment?',
      answer: 'Rupayya provides formal loan agreements and repayment schedules. In case of default, we offer mediation services to help resolve disputes. However, Rupayya does not guarantee loans or provide collection services. Users should only lend amounts they are comfortable with and consider the relationship.'
    },
    {
      question: 'What documents are required for KYC verification?',
      answer: 'For KYC verification, we require a government-issued ID (Aadhaar, PAN, or Passport), a recent photograph, and address proof. All documents are securely encrypted and stored. Verification typically completes within 24 hours of document submission.'
    },
    {
      question: 'Is there a limit on how much I can lend or borrow?',
      answer: 'Yes, Rupayya has transaction limits based on your verification level. New users can transact up to ₹50,000, verified users up to ₹2,00,000, and premium users up to ₹5,00,000. These limits help maintain security and compliance with regulatory guidelines.'
    },
    {
      question: 'How are interest rates determined on Rupayya?',
      answer: 'Interest rates are mutually agreed upon between the lender and borrower within RBI guidelines. Rupayya provides a suggested range based on market rates, but the final rate is decided by the parties involved. We ensure all rates comply with legal limits.'
    },
    {
      question: 'Can I prepay a loan before the due date?',
      answer: 'Yes, borrowers can prepay loans at any time without any prepayment penalties. The lender receives the principal amount along with interest calculated up to the prepayment date. Early repayment is encouraged and helps build trust between parties.'
    },
    {
      question: 'How does Rupayya ensure data privacy?',
      answer: 'We follow strict data protection protocols including encryption, access controls, and regular security audits. Personal and financial data is never shared with third parties without explicit consent. We comply with Indian data protection laws and regulations.'
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        
        {/* Header */}
        <div className={styles.header}>
          <h1 className={styles.title}>Frequently Asked Questions</h1>
          <p className={styles.subtitle}>Find answers to common questions about Rupayya</p>
        </div>

        {/* FAQ List */}
        <div className={styles.faqList}>
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`${styles.faqItem} ${activeIndex === index ? styles.active : ''}`}
            >
              <div 
                className={styles.faqQuestion}
                onClick={() => toggleFAQ(index)}
              >
                <h3 className={styles.questionText}>{faq.question}</h3>
                <span className={styles.toggleIcon}>
                  {activeIndex === index ? '−' : '+'}
                </span>
              </div>
              
              <div className={styles.faqAnswer}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default FAQ;